import { styled } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import { completenessLevelForScore, COMPLETENESS_LEVEL_TRANSLATION_KEY } from '@constants/companies';
import { useLiveScoreValue } from './LiveScoreProvider';
import ScoreReadout from './ScoreReadout';

const Wrapper = styled(ButtonBase)({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 8px',
    margin: '-4px -8px',
    borderRadius: 8,
    font: 'inherit',
    '&:hover': {
        backgroundColor: 'var(--action-hover)',
    },
    '@media (max-width: 600px)': {
        margin: 0,
    },
});

const ScoreTitle = styled(Typography)({
    color: 'var(--text-primary)',
    marginRight: 8,
    '@media (max-width: 1024px)': {
        display: 'none',
    },
});

const FooterScore = ({ onClick }) => {
    const { t } = useTranslation();
    const { percent } = useLiveScoreValue();
    const levelLabel = t(COMPLETENESS_LEVEL_TRANSLATION_KEY[completenessLevelForScore(percent)]);
    return (
        <Wrapper
            component="div"
            onClick={onClick}
            aria-label={`${t('SettingsCompanies.optimizationScore')}: ${percent}% ${levelLabel}`}
        >
            <ScoreTitle variant="subtitle2" component="span">
                {t('SettingsCompanies.optimizationScore')}:
            </ScoreTitle>
            <ScoreReadout percent={percent} />
        </Wrapper>
    );
};

export default FooterScore;
